import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { GetTunnelSectionsFiltered$Params } from 'src/app/server-api/fn/tunnel-section-controller/get-tunnel-sections-filtered';
import { CalculationStatusType, TunnelSectionFilterDto, TunnelStatusType } from 'src/app/server-api/models';
import { TunnelSectionControllerService } from 'src/app/server-api/services';
import { ListComponent } from 'src/app/utils-flc/list/list.component';
import { TunnelSectionsService } from '../tunnel-sections.service';

@Component({
  selector: 'app-tunnel-sections-list',
  templateUrl: './tunnel-sections-list.component.html',
  styleUrls: ['./tunnel-sections-list.component.css']
})
export class TunnelSectionsListComponent  extends ListComponent
 {

  toSetRowClickedSubscription: Subscription;

  jumpToId: string;

  constructor(public override translate: TranslateService, public override sidenavService: SideNavService, private tunnelSectionService: TunnelSectionControllerService,
    private tsService: TunnelSectionsService) {
      super(translate, sidenavService);

      this.constructorName = 'TunnelSectionsList';
    }

  override ngOnInit(): void {

    this.placeholderSearchText = 'tunnel-section.search';
    this.exportPrefix = 'tunnel-sections_';
    this.defaultSort = {active: 'startChainage', direction: 'asc'};
    this.primarySort = {active: 'startChainage', direction: 'asc'};

    super.ngOnInit();

    this.toSetRowClickedSubscription = this.tsService.sectionClickedOnMap.subscribe((id) => {
      this.jumpToId = id;
      this.paginator.pageIndex = 0;
      this.fillDataSource();
    });
  }


  override initAfterRoutePath()
  {
    this.translate
    .get(['tunnel-section.button_create', 'icon_refresh', 'action_show', 'tunnel-section.calc-status', 'tunnel-section.tunnel-status'
  ])
    .subscribe((translations: string[]) => {
      this.translations = translations;
      this.topMenuIcons = [
        //{icon: "add", title: translations['tunnel_section.button_create'], routerLink: RouterLinkEnum.TUNNEL_SECTIONS.toString() + "new", clickMethod: "dummy"},
        {icon: "refresh", title: translations['icon_refresh'], routerLink: null, clickMethod: "refresh"}
      ];
      this.actions = [
        {icon: "playlist_add", title: translations['action_show'], routerLink: RouterLinkEnum.TUNNEL_SECTIONS.toString(), clickMethod: "dummy"}
      ];

      this.displayedColumns = ['actions', 'name', 'startChainage', 'maxPrecSpecs', 'stressPatternAvg', 'calcStatus', 'calculationInProgress', 'tunnelStatus', 'lastModificationDate', 'latestError'];
      this.filterFields = ['', translations['tunnel-section.calc-status'], translations['tunnel-section.tunnel-status']];
    });
  }

  override refresh(): void {
    {
      this.jumpToId = null;
      this.clickedRow(null);
      super.refresh();
    }
  }
  override ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this.toSetRowClickedSubscription) this.toSetRowClickedSubscription.unsubscribe();
  }

  override getItems() {
    super.getItems();

    //when all data in 1 get (see getAllTunnelSections) all data will be in this.fullDataSource
    if (!this.fullDataSource || !this.fullDataSource.data || this.fullDataSource.data.length === 0)
    {
      this.getAllTunnelSections();
    }
    else
    {
      this.fillDataSource();
      this.sidenavService.setLoading(false);
    }
  }

  getAllTunnelSections()
  {
    let filterRequest: string = this.filter ? this.filter.nativeElement.value : '';
    let bodyRequest:TunnelSectionFilterDto = {  };
    for (let filter of this.filters)
    {
       if (filter.field === '') filterRequest = filter.value;
       if (filter.field === this.translations['tunnel-section.calc-status']) bodyRequest.calcStatus = this.getCalcStatus(filter.value);
       if (filter.field === this.translations['tunnel-section.tunnel-status']) bodyRequest.tunnelStatus = this.getTunnelStatus(filter.value);
    }

    let request:GetTunnelSectionsFiltered$Params = {
      page: 0,
      size: 9999,
      sort: [this.dataSource.sort.active + ',' + this.dataSource.sort.direction],
      filter: filterRequest,
      body: bodyRequest
    };
    this.tunnelSectionService.getTunnelSectionsFiltered(request).subscribe(
            value  => {
          this.fullDataSource.data = value['content'];
          this.fillDataSource();

          this.totalElements = value['totalElements'];
        }
        ,
        error => {
          console.error(JSON.stringify(error));
          this.sidenavService.setLoading(false);
        }
          ,
          () => {
            this.sidenavService.setLoading(false);
          }
          );
  }

  fillDataSource()
  {
    let start = (this.paginator.pageIndex * this.paginator.pageSize);
    let end = start + this.paginator.pageSize;
    this.dataSource.data = this.fullDataSource.data.slice(start, end);
    this.listIds = this.dataSource.data.map(d => d.id);

    //jump to a certain row
    let found: boolean = this.jumpToId ? false : true;
    if (!found)
    {
      this.dataSource.data.forEach(l => {
        if (l.id === this.jumpToId) {
          found = true;
          super.clickedRow(l.id);
        }
      });
      if (!found)
        this.paginator.nextPage();
      else
      {
        this.jumpToId = null;
      }
    }
  }

  override clickedRow(id: string): void {
    super.clickedRow(id);
    this.tsService.selectSectionOnMap(this.clickedRowId);
  }

  getCalcStatus(code: string)
  {
    var keys = Object.keys(CalculationStatusType);
    var result: CalculationStatusType;

    keys.forEach((obj, index) => {
      if (code.toUpperCase() === obj.toUpperCase()) {
        result = CalculationStatusType[obj];
      }
    });
    return result;
  }

  getTunnelStatus(code: string)
  {
    var keys = Object.keys(TunnelStatusType);
    var result: TunnelStatusType;

    keys.forEach((obj, index) => {
      if (code.toUpperCase() === obj.toUpperCase()) {
        result = TunnelStatusType[obj];
      }
    });
    return result;
  }

}